import overview from 'api/document/overview';

const mutatorMap = {
    creditnote: 'setLinkedCreditNotes',
    purchase: 'setLinkedPurchases',
    expense: 'setLinkedExpenses',
    item: 'setLinkedItems',
    custom: 'setLinkedCustoms',
    timetracking: 'setLinkedTimetrackings',
};
const resourceMap = {
    creditnote: 'parent',
    purchase: 'linked/purchase',
    expense: 'linked/expense',
    item: 'row',
    custom: 'linked/custom',
    timetracking: 'linked/timetracking',
};
const stateMap = {
    creditnote: 'creditnotes',
    purchase: 'purchases',
    expense: 'expenses',
    item: 'rows',
    custom: 'customs',
    timetracking: 'timetrackings',
};

/** @type {Promise|null} */
let docFilePromise = null;

export default {
    cancelInvoiceByCreditnote: function ({ state }) {
        return overview.cancelInvoiceByCreditnote(state.docid);
    },
    getAccountingCodes: function ({ commit }, query) {
        return overview
            .getAccountingCodes(query)
            .then((codes) => commit('setAccountingCodes', codes));
    },
    getAccountingCodeForRow: function ({ state, commit }) {
        return overview.getAccountingCodeForRow(state.seletedRow).then((code) => {
            commit('updateRow', { id: state.seletedRow, accountingCodeId: code.accountingCodeId });
            commit('addAccountingCodes', [
                {
                    id: code.accountingCodeId,
                    label: code.accountingCode.label,
                    code: code.accountingCode.code,
                },
            ]);
        });
    },
    setAccountingCodeForRow: function ({ state, commit }, accountingCodeId) {
        return overview
            .setAccountingCodeForRow(state.seletedRow, accountingCodeId)
            .then(() =>
                commit('updateRow', { id: state.seletedRow, accountingCodeId: accountingCodeId }),
            );
    },
    toggleDunningForDoc: function ({ state, commit }) {
        return overview
            .toggleDunningForDoc(state.doctype, state.docid, state.dunningState)
            .then(() => commit('toggleDunning'));
    },
    getSentDunnings: function ({ state, commit }, page) {
        return overview
            .getSentDunnings(state.doctype, state.docid, page)
            .then((dunnings) => commit('setSentDunnings', dunnings));
    },
    getPlannedDunnings: function ({ state, commit }) {
        if (state.dunningState != 'enabled') {
            commit('setPlannedDunnings', { data: [], total: 0 });
            return new Promise(() => {});
        }
        return overview
            .getPlannedDunnings(state.doctype, state.docid)
            .then((dunnings) => commit('setPlannedDunnings', dunnings));
    },
    getLinkedResource: function ({ state, commit }, context) {
        return overview.getLinkedResource(state.doctype, state.docid, context).then((response) => {
            if (context == 'creditnote' || context == 'expense') {
                for (const key in response) {
                    response[key].canEdit =
                        state.docNumberFormat.currencyid == response[key].currency;
                }
            }
            commit(mutatorMap[context], response);
        });
    },
    deleteLink: function ({ commit }, { id, context }) {
        return overview.deleteLink(id).then((response) => {
            const mutatorMap = {
                purchase: 'deleteLinkedPurchase',
                expense: 'deteleLinkedExpense',
                custom: 'deleteLinkedCustom',
                timetracking: 'deleteLinkedTimetracking',
            };
            commit(mutatorMap[context], response.id);
        });
    },
    addCustomLink: function ({ state, commit }, customEntry) {
        return overview
            .addCustomLink(state.doctype, state.docid, customEntry)
            .then((response) => {
                const entry = {};
                entry.id = response.custom.id;
                entry.customId = response.custom.customId;
                entry.linkedId = response.custom.linkedId;
                entry.label = response.custom.label;
                entry.processMargin = response.custom.processMargin == 'Y';
                entry.qt = response.custom.qt;
                entry.unitAmount = response.custom.amounttaxefree;
                entry.totalAmount = response.custom.totalamount;
                commit('addLinkedCustom', entry);
            })
            .catch((errors) => {
                throw errors;
            });
    },
    updateCustomLink: function ({ state, commit }, customEntry) {
        return overview
            .updateCustomLink(state.doctype, state.docid, customEntry)
            .then((response) => {
                const oldcustom = state.customs.find(
                    (custom) => custom.id == response.custom.linkedId,
                );
                const entry = {};
                entry.id = response.custom.linkedId;
                entry.customId = response.custom.customId;
                entry.linkedId = response.custom.linkedId;
                entry.label = response.custom.label;
                entry.processMargin = oldcustom.processMargin;
                entry.qt = response.custom.qt;
                entry.unitAmount = response.custom.amounttaxefree;
                entry.totalAmount = response.custom.totalamount;
                commit('updateLinkedCustom', entry);
            })
            .catch((errors) => {
                throw errors;
            });
    },
    getStatistics: function ({ state, commit }) {
        return overview
            .getStatistics(state.doctype, state.docid)
            .then((statistics) => {
                commit('setStatistics', statistics);
            })
            .catch((errors) => {
                throw errors;
            });
    },
    processMargin: function ({ state, commit }, { context, ids }) {
        return overview
            .processMargin(state.doctype, state.docid, resourceMap[context], ids)
            .then((response) => {
                const oldLinked = state[stateMap[context]];
                const newLinked = oldLinked.map((link) => {
                    link.processMargin = ids.find((el) => el == link.id) !== undefined;
                    return link;
                });
                commit(mutatorMap[context], newLinked);
            })
            .catch((errors) => {
                throw errors;
            });
    },
    validate: function ({ state }, payload) {
        const date = !!payload ? payload.date : undefined;
        return overview.validate(state.doctype, state.docid, date);
    },
    getDocFile: async function ({ state }) {
        if (!state.fileId || state.fileId === '0') {
            state.docFile = null;
            return;
        }

        if (!state.hasAlreadyFetchedDocFile) {
            state.hasAlreadyFetchedDocFile = true;
            docFilePromise = ApiClient.get(`/files/${state.fileId}`);
        }

        try {
            state.docFile = await docFilePromise;
        } catch {
            state.docFile = null;
        }
    },
};
